
import { getActions } from '../sagas';

 /**
 * Command `data.setDatawinsetDatawinFetchAttributes`
 *
 * @typedef {Object} MultSceneForApp~Data~Commands~SetDatawinDataModelItemId
 * @property {string} command - name of command, has value `data.setDatawinObjectList`
 * @property {string} dataModelItemId - ID of data model item
 * @property {Object} attributes - list of attributes
 * @property {Object} geom - geometry
 */
function setDatawinFetchAttributes(params, dispatch, store) {
    const dataActions = getActions(dispatch);
    const geom = params.geom ? params.geom.geometry : null;

    dataActions.setDatawinFetchPanelVisibility(true);
    dataActions.setDatawinFetchAttributes(
        params.dataModelItemId, params.attributes
    );
    dataActions.setDatawinFetchGeom(
        params.dataModelItemId, geom
    );
}

export default {
    name: 'data.setDatawinFetchAttributes',
    execute: setDatawinFetchAttributes
}
